import { Component, Injectable, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sibling-link',
  templateUrl: './sibling-link.component.html',
  styleUrls: ['./sibling-link.component.css']
})
@Injectable({
  providedIn: 'root',
})
export class SiblingLinkComponent implements OnInit {
  @Input() relatedLink: any;

  constructor() { }
  ngOnInit(): void {
      
    throw new Error('Method not implemented.');
  }
}
